var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendarDay",class:{
  "day--puzzleAvailable": _vm.dayEntry.puzzleAvailable,
  "day--notCurrentMonth": !_vm.dayEntry.currentMonth,
  "day--clickable": _vm.clickable,
  "day--notClickable": !_vm.clickable,
},on:{"click":_vm.handleClick}},[(_vm.completedPuzzle)?_c('div',{staticClass:"day__completedMark"}):_vm._e(),(_vm.currentPuzzle)?_c('div',{staticClass:"day__curentDayMark"}):_vm._e(),_c('div',{staticClass:"day__label"},[_vm._v(" "+_vm._s(_vm.dayEntry.date.getDate())+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }